import PropTypes from 'prop-types'

const pagination = PropTypes.shape({
  currentPage: PropTypes.number.isRequired,
  totalCount: PropTypes.number,
  limitValue: PropTypes.number,
})

const shareable = PropTypes.shape({
  id: PropTypes.number,
  type: PropTypes.string,

  is_published: PropTypes.bool,
  share_uri: PropTypes.string,
  tweet_text: PropTypes.string,

  host: PropTypes.string,

  allow_embedding: PropTypes.bool,
  can_grant_group_permissions: PropTypes.bool,
  can_grant_user_permissions: PropTypes.bool,
})

const publishableResource = PropTypes.shape({
  id: PropTypes.number.isRequired,
  publish_status_code: PropTypes.number.isRequired,
})

const userProps = {
  id: PropTypes.number.isRequired,
  display_name: PropTypes.string.isRequired,
  profile_link: PropTypes.string.isRequired,
}
const managedUserProps = {
  ...userProps,
  confirmed: PropTypes.bool.isRequired,
}
const currentUserProps = {
  ...userProps,
  available_seats: PropTypes.number.isRequired,
  num_unpublished_timelines_available: PropTypes.number.isRequired,
  can_manage_account_users: PropTypes.bool.isRequired,
  can_create_private: PropTypes.bool.isRequired,
}

const user = PropTypes.shape(userProps)
const managedUser = PropTypes.shape(managedUserProps)
const currentUser = PropTypes.shape(currentUserProps)

const group = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
})

const membership = PropTypes.shape({
  id: PropTypes.number.isRequired,
  group_id: PropTypes.number.isRequired,
  user_id: PropTypes.number.isRequired,
})

const permissionProps = {
  id: PropTypes.number.isRequired,
  permissable_type: PropTypes.string.isRequired,
  permissable_id: PropTypes.number.isRequired,
  permissionable_type: PropTypes.string.isRequired,
  permissionable_id: PropTypes.number.isRequired,
  role: PropTypes.string.isRequired,
}
const permissionWithAbilitiesProps = {
  ...permissionProps,
  revocable: PropTypes.bool.isRequired,
}
const permission = PropTypes.shape(permissionProps)
const permissionWithAbilities = PropTypes.shape(permissionWithAbilitiesProps)

const image = PropTypes.shape({
  src: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
})

const colorScheme = PropTypes.shape({
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.string.isRequired,
  tertiary: PropTypes.string.isRequired,
  highlight: PropTypes.string.isRequired,

  // Note: these are not user customizable
  darkText: PropTypes.string.isRequired,
  lightText: PropTypes.string.isRequired,
})

const editableDate = PropTypes.shape({
  year: PropTypes.string,
  month: PropTypes.string,
  day: PropTypes.string,
  isBCE: PropTypes.bool,
})

const imageUrlShape = PropTypes.shape({
  src: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
})

const restPhotoShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  image_urls: PropTypes.shape({
    small_landscape: imageUrlShape,
  }),
  image_processing_complete: PropTypes.bool,
})

const jsonapiPhotoShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  attributes: PropTypes.shape({
    image_urls: PropTypes.shape({
      small_landscape: imageUrlShape,
    }),
    image_processing_complete: PropTypes.bool,
  }),
})

const photo = PropTypes.oneOfType([restPhotoShape, jsonapiPhotoShape])

const invitation = PropTypes.shape({
  id: PropTypes.number,
  recipient_display_name: PropTypes.string,
  status: PropTypes.string,
})

const serializableError = PropTypes.shape({
  status: PropTypes.number,
  message: PropTypes.string.isRequired,
  fieldErrors: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
})

export default {
  pagination,
  shareable,
  publishableResource,
  currentUser,
  user,
  managedUser,
  group,
  membership,
  permission,
  permissionWithAbilities,
  image,
  colorScheme,
  editableDate,
  photo,
  invitation,
  serializableError,
}
